export const PERIOD_TYPE_MONTHLY = 'MONTHLY';
export const PERIOD_TYPE_QUARTERLY = 'QUARTERLY';
export const PERIOD_TYPE_SEMIANNUALLY = 'SEMIANNUALLY';
export const PERIOD_TYPE_YEARLY = 'YEARLY';

export function getPeriodTypeSingularLabel(periodType) {
  if (periodType === PERIOD_TYPE_MONTHLY) {
    return 'mês';
  } else if (periodType === PERIOD_TYPE_QUARTERLY) {
    return 'trimestre';
  } else if (periodType === PERIOD_TYPE_SEMIANNUALLY) {
    return 'semestre';
  } else if (periodType === PERIOD_TYPE_YEARLY) {
    return 'ano';
  }
  return '';
}

export function getPeriodTypeLabel(periodType) {
  if (periodType === PERIOD_TYPE_MONTHLY) {
    return 'Mensal';
  } else if (periodType === PERIOD_TYPE_QUARTERLY) {
    return 'Trimestral';
  } else if (periodType === PERIOD_TYPE_SEMIANNUALLY) {
    return 'Semestral';
  } else if (periodType === PERIOD_TYPE_YEARLY) {
    return 'Anual';
  }
  return '';
}

export function getPeriodTypeIntoMonths(periodType) {
  if (periodType === PERIOD_TYPE_MONTHLY) {
    return 1;
  } else if (periodType === PERIOD_TYPE_QUARTERLY) {
    return 3;
  } else if (periodType === PERIOD_TYPE_SEMIANNUALLY) {
    return 6;
  } else if (periodType === PERIOD_TYPE_YEARLY) {
    return 12;
  }
  return 1;
}
